import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  private baseUrl: string = '/api/tracking';
  private order = new Object();
  private readonly webMasterId: string | null = localStorage.getItem('webMasterId');

  constructor(private http: HttpClient) { }

  // getAllShippedOrder(page, size) {
  //   return this.http.get(this.baseUrl + '/getOrdersTracked' + '?page=' + page + '&size=' + size);
  // }

 getAllShippedOrder(page: number, size: number): Observable<any> {
  let url = `${this.baseUrl}/getOrdersTracked?page=${page}&size=${size}`;

  if (this.webMasterId) {
    url += `&webmaster=${this.webMasterId}`;
  }

  return this.http.get<any>(url);
}

  getShippedOrderByStatus(status, page, size) {
    return this.http.get(this.baseUrl + '/getOrdersTrackedByStatus?status=' + status + '&page=' + page + '&size=' + size);
  }

  getTrackingDetailsByOrder(id) {
    return this.http.get(this.baseUrl + '/getDetailsTracking?id=' + id);
  }


  // getNbreAllOrder() {
  //   return this.http.get(this.baseUrl + '/numberAllOrder');
  // }

  getNbreAllOrder(): Observable<any> {
    let url = `${this.baseUrl}/numberAllOrder`;
  
    if (this.webMasterId) {
      url += `?webmaster=${this.webMasterId}`;
    }
  
    return this.http.get<any>(url);
  }

  // getNbreOrderByStatus(status) {
  //   return this.http.get(this.baseUrl + '/numberOrdersByStatus?status=' + status);
  // }

  getNbreOrderByStatus(status: string): Observable<any> {
    let url = `${this.baseUrl}/numberOrdersByStatus?status=${status}`;
    if (this.webMasterId) {
      url += `&webmaster=${this.webMasterId}`;
    }
    return this.http.get<any>(url);
  }

  getNbreProcessOrder() {
    return this.http.get(this.baseUrl + '/numberProcessOrder');
  }

  getNbreTransitOrder() {
    return this.http.get(this.baseUrl + '/numberTransitOrder');
  }

  getNbreDeliveredOrder() {
    return this.http.get(this.baseUrl + '/numberDeliveredOrder');
  }

  getNbreExceptionOrder() {
    return this.http.get(this.baseUrl + '/numberExceptionOrder');
  }


  getInformation() {
    return this.http.get(this.baseUrl + '/Report');
  }
  getShippingMethod() {
    return this.http.get(this.baseUrl + '/ReportShippingMethod');
  }

  getCountryByShippingMethod() {
    return this.http.get(this.baseUrl + '/ReportR');
  }

  getReviews() {
    return this.http.get(this.baseUrl + '/vote');
  }





  /*sendEmail(email:Object){

    return this.http.post(this.baseUrl+'/email',JSON.stringify(email),  this.options).map((response:Response)=>response.json())
      .catch(this.errorHandler);
  }*/





  // sendEmail(email: Object) {
  //   return this.http.post('/api/tracking/email', JSON.stringify(email));
  // }



  function(req, res, next) {

    // Website you wish to allow to connect
    // res.setHeader('Access-Control-Allow-Origin', environment.BACK_TRACKING);

    // Request methods you wish to allow
    res.setHeader('Access-Control-Allow-Methods', 'GET, POST, OPTIONS, PUT, PATCH, DELETE');

    // Request headers you wish to allow
    res.setHeader('Access-Control-Allow-Headers', 'X-Requested-With,content-type');

    // Set to true if you need the website to include cookies in the requests sent
    // to the API (e.g. in case you use sessions)
    res.setHeader('Access-Control-Allow-Credentials', true);

    // Pass to next layer of middleware
    next();
  };



  // downloadPDF2(): any {
  //   return this.http.get(this.baseUrl + '/download', { responseType: 'blob', observe: 'response' }).pipe(
  //     map((res:HttpResponse<Blob>) => {
  //       saveAs(res, "tracking.pdf");
  //       return res;
  //     }
  //   )


  // downloadPDF(): any {
  //   return this.http.get(this.baseUrl+'/download', { responseType: ResponseContentType.Blob }).map(
  //   (res) => {
  //       return new Blob([res.blob()], { type: 'application/pdf' })
  //   }
  //   )}


  getOrederByCode(code) {
    return this.http.get(this.baseUrl + '/OrderTrackingByCode?code=' + encodeURIComponent(code));
  }
  getOrederByCodeAndStaus(code,status) {
    return this.http.get(this.baseUrl + '/OrderTrackingByCodeAndStatus?code=' + encodeURIComponent(code)+'&status='+status);
  }
  getOrederByTracNumber(code) {
    return this.http.get(this.baseUrl + '/OrderBytrackingApi?code=' + code);
  }

  errorHandler(error: Response) {

    return Observable.throw(error || "SERVER ERROR");
  }
  setter(order: Object) {
    this.order = order;
  }

  getter() {
    return this.order;
  }




  /*sendEmail(email:Object){

      return this.http.post(this.baseUrl+'/email',JSON.stringify(email),  this.options).map((response:Response)=>response.json())
        .catch(this.errorHandler);
    }*/



  getOrdersByDateRange(fdate, todate) {
    return this.http.get(this.baseUrl + '/OrdersTrackingByDateRange?fdate=' + fdate+ '&todate=' + todate );
  }

  getProcessedOrdersByDateRange(fdate, todate) {
    return this.http.get(this.baseUrl + '/ProcessedOrdersTrackingByDateRange?fdate=' + fdate+ '&todate=' + todate);
  }


  getTransitOrdersByDateRange(fdate, todate) {
    return this.http.get(this.baseUrl + '/TransitOrdersTrackingByDateRange?fdate=' + fdate+ '&todate=' + todate);
  }

  getNotFoundOrdersByDateRange(fdate, todate) {
    return this.http.get(this.baseUrl + '/NotFoundOrdersTrackingByDateRange?fdate=' + fdate+ '&todate=' + todate);
  }


  getOrdersCategoryByDateRange(fdate, todate, category) {
    return this.http.get(this.baseUrl + '/OrdersTrackingCategoryByDateRange?fdate=' + fdate+ '&todate=' + todate+'&category=' + category);
  }









}
